export function getPathSliceFromIndex(path: string, index: number) {
  return path.slice(1).split("/").slice(index).filter(Boolean).join("/");
}
